export function receiptQuiz(items, steps) {
  let allPreviousStepsCompleted = true;
  //find each step in this.stepJson that is not a receipt and check if it is completed
  steps.forEach((item) => {
    if (!item.isReceipt) {
      if (!item.isCompleted) {
        allPreviousStepsCompleted = false;
      }
    }
  });

  let answerlist = "";
  let receiptQuiz = items
    .map((item, index) => {
      return `
    <div class="quiz-slide bg-white border border-blue ${index === 0 && allPreviousStepsCompleted ? `slide-active` : ``}" data-index="${index}">
        <div class="grid grid-cols-12 p-6 pt-10 max-w-lg">
          <div class="text-blue font-black text-lg col-span-9">${item.content.properties.title}</div>
          <div class="col-span-2 col-start-11">${index + 1} / ${items.length}</div>
          <div class="col-span-12 pt-8">
            <ul>
              ${(answerlist = item.content.properties.answers.items
                .map((answer, answerIndex) => {
                  return `
                    <li class="flex items-center pb-8 gap-x-5">
                      <input type="radio" id="answer-${answer.content.id}" name="answer-${index + 1}" value="${answer.content.properties.isCorrect}" class="visually-hidden">
                      <label for="answer-${answer.content.id}" class="${answerIndex == 0 ? "A" : answerIndex == 1 ? "B" : answerIndex == 2 ? "C" : "D"}">${answer.content.properties.questionAnswer}</label>
                    </li>
                  `;
                })
                .join(""))}
            </ul>
            <div data-false class="invisible flex items-center justify-start gap-x-5 pt-4">
                <p class="font-bold text-small">Svaret er forkert, prøv igen</p>
            </div>
          </div> 
        </div>
    </div>
    `;
    })
    .join("");

  receiptQuiz = `<div class="guide-quiz-outer">
                  <div class="guide-quiz-inner flex flex-nowrap gap-5 items-stretch">
                    ${receiptQuiz}
                  </div>                  
                </div>`;

  return receiptQuiz;
}
